// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"602":"2d99383f19009395","2888":"7de780300757a093"}[chunkId] + ".css";
};